export default __webpack_public_path__ + "static/media/quickstart-step-7.6351d4eb.jpg";